import React, { FC } from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { FieldOption, StatusGroup } from 'api/tasks';
import { useStatusPickerContext } from './context';
import { StatusPickerOptionIcon } from './option-icon';

const Option = styled(components.Option)`
  align-items: center;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  display: flex;

  &.status-picker__option {
    padding: 0 var(--spacing-04);
    border-left: solid 4px transparent;
  }

  &.status-picker__option--is-focused {
    background: var(--item-hover-bg);
  }

  &.status-picker__option--is-selected {
    background: var(--coolest-gray-10);
    border-left-color: var(--primary-color);
    color: var(--gray-100);
  }

  > svg {
    margin-right: var(--spacing-03);
  }
`;

export const StatusPickerOption: FC<{
  data: FieldOption<StatusGroup>;
}> = ({ data, ...rest }) => {
  // TODO: Stop using implicit API @Shajansheriff
  const { type } = useStatusPickerContext();

  return (
    <span
      data-cy={`status_picker.option.label.${data.label.replace(' ', '')}`}
      data-option-id={`staus_picker.option.id.${data.value}`}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading,@typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Option {...rest}>
        <StatusPickerOptionIcon
          data={data as Required<FieldOption<StatusGroup>>}
          progress={10}
          showTooltip={false}
          type={type}
        />
        {data.label}
      </Option>
    </span>
  );
};
